import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import useHttpHook from "../../../../Hooks/HttpHook";
import { DELETECARDS } from "../../../../utils/ApiConstant";
import { OrderLanguage } from "../../../../utils/Languages";
import Input from "../../../UiElement/FormElement/Input";
import ModalWrapper from "../../../Common/Portals/ModalWrapper";
import { toast } from "react-toastify";
import MainComponentWrapper from "../../../Common/MainComponentWrapper";
import { showErrorToast } from "../../../../utils/notify";
const CheckoutForm = ({
  setCard,
  cardList,
  register,
  errors,
  selectedCard,
  getUserCards,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, sendRequest, error, successmessage] = useHttpHook();

  const [deleteModal, setDeleteModal] = useState(false);

  const [deleteCardId, setDeleteCardId] = useState("");

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  useEffect(() => {
    if (successmessage) {
      if (toast.isActive(successmessage) === false) {
        toast.success(successmessage);
      }
    }
  }, [successmessage]);

  const deleteCardApi = async () => {
    let event = await sendRequest(`${DELETECARDS}/${deleteCardId}`, {
      method: "delete",
    });

    if (event.status === 1) {
      getUserCards();
      setDeleteModal(false);
    }
  };

  return (
    <MainComponentWrapper Loading={loading} errorInfo={error}>
      <div className="event-checkout-card-list">
        {cardList?.map((card, index) => (
          <label
            className={`event-checkout-card-option${
              selectedCard === card.cardId ? " is-selected" : ""
            }`}
            key={card._id || index}
          >
            <input
              type="radio"
              name="card"
              checked={selectedCard === card.cardId}
              onChange={() => setCard(card.cardId)}
            />
            <div className="event-checkout-card-copy">
              <strong>Card ending with {card.cardNumber}</strong>
              <span className="event-checkout-card-meta">{card.name}</span>
              <span className="event-checkout-card-expiry">
                {card.expiryMonth}/{card.expiryYear}
              </span>
            </div>
            <span
              className={`event-checkout-card-brand-badge ${
                card.cardType?.toLowerCase() === "visa" ? "is-visa" : "is-mc"
              }`}
            >
              {card.cardType?.toLowerCase() === "american express"
                ? "AMEX"
                : card.cardType?.toUpperCase()}
            </span>
            <button
              type="button"
              className="event-checkout-card-remove"
              aria-label="Delete card"
              onClick={(event) => {
                event.preventDefault();
                setDeleteCardId(card?._id);
                setDeleteModal(true);
              }}
            >
              <i className="las la-times"></i>
            </button>
          </label>
        ))}
      </div>

      <div className="event-checkout-add-card">
        <div className="event-checkout-add-card-label">
          {OrderLanguage.CheckoutForm.paymentMethod.addCard}
        </div>
        <label
          className={`event-checkout-card-option${isOpen ? " is-selected" : ""}`}
        >
          <input
            type="radio"
            name="card"
            checked={isOpen}
            onChange={() => {
              setIsOpen(!isOpen);
              setCard("");
            }}
          />
          <div className="event-checkout-card-copy event-checkout-card-copy--simple">
            <strong>{OrderLanguage.CheckoutForm.paymentMethod.card}</strong>
          </div>
          <div className="event-checkout-card-brands">
            <span className="event-checkout-card-brand is-mc">MC</span>
            <span className="event-checkout-card-brand is-visa">VISA</span>
            <span className="event-checkout-card-brand is-amex">AMEX</span>
          </div>
        </label>

        {isOpen && (
          <div className="event-checkout-new-card-form">
            <div className="event-checkout-card-fields-grid">
              <Input
                element="number"
                CustomFormGroupCls="event-checkout-field"
                InputClassName="event-checkout-input"
                Label={
                  OrderLanguage.CheckoutForm.paymentMethod.form.cardNumber.label
                }
                ValidationArr={[{ Type: "required" }]}
                FieldName="cardNumber"
                Register={register}
                Errors={errors}
              />
              <div className="event-checkout-field">
                <label htmlFor="expireDate">
                  {
                    OrderLanguage.CheckoutForm.paymentMethod.form.expiryDate
                      .label
                  }
                </label>
                <div className="event-checkout-expiry-grid">
                  <Input
                    element="number"
                    placeholder="Month"
                    InputClassName="event-checkout-input"
                    FieldName="expiryMonth"
                    Register={register}
                    Errors={errors}
                    ValidationArr={[
                      { Type: "required" },
                      { Type: "maxLength", value: 2 },
                    ]}
                  />
                  <Input
                    element="number"
                    placeholder="Year"
                    InputClassName="event-checkout-input"
                    FieldName="expiryYear"
                    Register={register}
                    Errors={errors}
                    ValidationArr={[
                      { Type: "required" },
                      { Type: "maxLength", value: 4 },
                    ]}
                  />
                </div>
              </div>
              <Input
                element="text"
                CustomFormGroupCls="event-checkout-field"
                InputClassName="event-checkout-input"
                Label={OrderLanguage.CheckoutForm.paymentMethod.form.cardName.label}
                ValidationArr={[{ Type: "required" }]}
                FieldName="name"
                Register={register}
                Errors={errors}
              />
              <Input
                element="password"
                CustomFormGroupCls="event-checkout-field"
                InputClassName="event-checkout-input"
                Label={OrderLanguage.CheckoutForm.paymentMethod.form.cvv.label}
                ValidationArr={[{ Type: "required" }]}
                FieldName="cvv"
                Register={register}
                Errors={errors}
              />
            </div>
          </div>
        )}
      </div>

      {deleteModal && (
        <ModalWrapper
          title={"Delet Card"}
          clickHandler={deleteCardApi}
          CloseModalHandler={() => setDeleteModal(false)}
        >
          <span>{"Are you sure to delete the card ?"}</span>
        </ModalWrapper>
      )}
    </MainComponentWrapper>
  );
};

export default CheckoutForm;
